import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueI18n from 'vue-i18n';
import VueMeta from 'vue-meta';
import VueCookies from 'vue-cookies';
import { stripLocale } from './seo';
import installLocalizedLink from './localized-link';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faUser,
    faComments
} from '@fortawesome/free-solid-svg-icons';
import {
  faWeibo,
    faWeixin,
    faAlipay,
    faQq,
    faSlack,
    faPaypal,
    faTwitter
} from "@fortawesome/free-brands-svg-icons";

Vue.config.productionTip = false

// 图标子集，由 scripts/subset-icons.py 生成（原文件 5856 个图标 / 312KB 字体，全站只用 14 个）
import "../public/css/mdi-subset.css";
import 'swiper/swiper-bundle.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { BootstrapVue } from 'bootstrap-vue'
var VueScrollTo = require('vue-scrollto');
import Scrollspy from 'vue2-scrollspy';
import VueYoutube from 'vue-youtube'
import vueVimeoPlayer from 'vue-vimeo-player'
import VueMasonry from 'vue-masonry-css'
import axios from "axios";
import moment from 'moment'

Vue.use(VueScrollTo, {
  duration: 3000,
  easing: "ease"
})

Vue.use(VueI18n);
Vue.use(VueMeta, { refreshOnceOnNavigation: true });
installLocalizedLink();
Vue.use(VueCookies);
Vue.use(BootstrapVue)
Vue.use(Scrollspy);
Vue.use(VueYoutube)
Vue.use(vueVimeoPlayer)
Vue.use(VueMasonry)
Vue.component('font-awesome-icon', FontAwesomeIcon);
library.add(
    faUser,
    faWeibo,
    faWeixin,
    faAlipay,
    faQq,
    faSlack,
    faTwitter,
    faPaypal,
    faComments
);

// 添加请求公参
axios.defaults.withCredentials=true;
axios.interceptors.request.use((config) => {
  config.params = {
    locale: getLang(),
    ...config.params
  };
  return config;
});
Vue.filter('formatDate', function(value) {
  return moment(value).format('YYYY-MM-DD HH:mm:ss')
})
Vue.filter('formatDate2', function(value) {
  return moment(value).format('YYYY/MM/DD')
})

const i18n = new VueI18n({
  locale: getLang(),
  messages: {
    'zh' : require("./locale/zh/lang"),
    'en' : require('./locale/en/lang')
  }
})

/**
 * 语言由 URL 路径唯一决定：/en/* 是英文，其余都是中文。
 *
 * 这里刻意没有 cookie / 浏览器语言的回退分支。一旦回退，同一个 URL 就会因访客而异
 * 地返回两种语言，搜索引擎无法稳定收录，hreflang 也会自相矛盾。
 * 访客的语言偏好只用来决定语言切换器高亮哪一项，不参与内容渲染。
 */
function getLang() {
  const lang = stripLocale(location.pathname).locale;
  Vue.$cookies.set("mirror-lang", lang);
  document.body.className = lang;
  return lang;
}

Vue.prototype.getLang = getLang;

// SPA 内部在 / 与 /en 之间跳转时，i18n 要跟着 URL 走
router.afterEach((to) => {
  const lang = stripLocale(to.path).locale;
  if (i18n.locale !== lang) {
    i18n.locale = lang;
    Vue.$cookies.set("mirror-lang", lang);
  }
  document.body.className = lang;
});

new Vue({
  i18n,
  router,
  render: h => h(App),
  mounted() {
    // 预渲染脚本（scripts/prerender.js）等这个事件后才抓取 HTML，
    // 保证抓到的是渲染完成的页面而不是空壳。
    this.$nextTick(() => {
      document.dispatchEvent(new Event('render-event'));
    });
  }
}).$mount('#app')

